import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import * as loginActions from "./../../redux/actions/login.action";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));

const Header = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const loginReducer = useSelector((state) => state.loginReducer);

  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: props.open,
        })}
      >
        <Toolbar>
          {!props.open && (
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={props.handleDrawerOpen}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" className={classes.title}>
            PRS System
            <Typography variant="subtitle1">Version : 5.0.0</Typography>
          </Typography>
          <Typography variant="subtitle1" style={{ marginRight: 20 }}>
            Hi ! {loginReducer.result.fullname + "   "}
          </Typography>
          <Button
            mr={5}
            color="inherit"
            variant="outlined"
            onClick={(e) => {
              dispatch(loginActions.logout({ ...props }));
            }}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default withRouter(Header);
